module.exports = __webpack_public_path__ + "static/media/S2P7_associated-cancer-risks-by-gene-type.4102d2ef.mp3";